import { render, staticRenderFns } from "./TotalDebtInfo.vue?vue&type=template&id=2f7182e2&scoped=true&"
import script from "./TotalDebtInfo.vue?vue&type=script&lang=js&"
export * from "./TotalDebtInfo.vue?vue&type=script&lang=js&"
import style0 from "./TotalDebtInfo.vue?vue&type=style&index=0&id=2f7182e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7182e2",
  null
  
)

export default component.exports